module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.stepForm <= 1) ? _c('div', {
    attrs: {
      "id": "title-container-form"
    }
  }, [_c('h2', {
    attrs: {
      "id": "title-form"
    }
  }, [_vm._v("Adicionar veículo(s) do plano")])]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 404) ? _c('div', {
    attrs: {
      "id": "title-container-form-404"
    }
  }, [_c('h2', {
    attrs: {
      "id": "title-form-mobile"
    }
  }, [_vm._v("Adicionar veículo(s) do plano manualmente")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "subtitle-form"
    }
  }, [_vm._v("( Todos os campos são obrigatórios )")])]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 0) ? _c('div', [_c('label', {
    attrs: {
      "for": "plate-input",
      "id": "plate-label"
    }
  }, [_vm._v("\n      Digite a placa do veículo\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "input-container"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|plateValid|plateExist'),
      expression: "'required|plateValid|plateExist'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.plate),
      expression: "plate",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control text-uppercase plate margin-t5",
    staticStyle: {
      "outline": "none"
    },
    attrs: {
      "id": "plate-input",
      "type": "text",
      "name": "plate",
      "data-vv-validate-on": "blur",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "maxlength": "7",
      "autocapitalize": "off"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "keydown": _vm.verificarTecla,
      "input": _vm.onPlateInput,
      "paste": _vm.tratarTextoColado,
      "change": function($event) {
        _vm.plate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "search-plate-button"
    },
    on: {
      "click": _vm.NetrinValidation
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/img/icons/icon-search.svg"),
      "alt": "Imagem de uma lupa"
    }
  })])]), _vm._v(" "), (_vm.plateAlreadyOn) ? _c('div', {
    attrs: {
      "id": "error-msg"
    }
  }, [_c('h2', [_vm._v("Placa já cadastrada!")])]) : _vm._e(), _vm._v(" "), (_vm.validatePlate || _vm.plateInvalida) ? _c('div', {
    attrs: {
      "id": "error-msg"
    }
  }, [_c('h2', [_vm._v("Placa Inválida!")])]) : _vm._e(), _vm._v(" "), (_vm.isMoto) ? _c('div', {
    attrs: {
      "id": "error-msg"
    }
  }, [_c('h2', [_vm._v("\n        Moto não tem permissão para fazer uso de tag. Cadastre outro tipo de\n        veículo.\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.plateValida) ? _c('div', {
    attrs: {
      "id": "transportador-container"
    }
  }, [_c('label', {
    attrs: {
      "id": "transportador-check"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.souTransportador),
      expression: "souTransportador"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.souTransportador) ? _vm._i(_vm.souTransportador, null) > -1 : (_vm.souTransportador)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.souTransportador,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.souTransportador = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.souTransportador = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.souTransportador = $$c
        }
      }, _vm.onTransportadorToggle]
    }
  }), _vm._v(" "), _c('span', [_vm._v("Sou transportador e quero receber VPO.")])]), _vm._v(" "), (_vm.souTransportador) ? _c('div', {
    attrs: {
      "id": "antt-box"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "antt-input-row"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cpfCnpjTransportador),
      expression: "cpfCnpjTransportador"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cpf-cnpj-input",
      "type": "text",
      "name": "cpfCnpjTransportador",
      "placeholder": "Digite o número CPF ou CNPJ do proprietário",
      "maxlength": "18",
      "spellcheck": "false",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.cpfCnpjTransportador)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.cpfCnpjTransportador = $event.target.value
      }, _vm.onCpfCnpjInput]
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "id": "consultar-antt-button",
      "type": "button",
      "disabled": _vm.anttLoading || !_vm.cpfCnpjValido || _vm.anttStatus === 'error'
    },
    on: {
      "click": _vm.consultarAntt
    }
  }, [(_vm.anttLoading) ? _c('span', {
    staticClass: "antt-spinner"
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.anttLoading ? "Consultando..." : "Consultar na ANTT") + "\n          ")])]), _vm._v(" "), (_vm.anttStatus === 'success') ? _c('div', {
    attrs: {
      "id": "antt-feedback-success"
    }
  }, [_c('svg', {
    attrs: {
      "width": "18",
      "height": "18",
      "viewBox": "0 0 18 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_166_8935)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16.3502 7.50011C16.6927 9.18109 16.4486 10.9287 15.6586 12.4515C14.8686 13.9742 13.5804 15.1802 12.0088 15.8681C10.4373 16.5561 8.67743 16.6845 7.02269 16.2319C5.36794 15.7793 3.91836 14.7732 2.91567 13.3812C1.91298 11.9892 1.41781 10.2955 1.51271 8.58265C1.60762 6.86977 2.28687 5.24118 3.4372 3.96849C4.58753 2.6958 6.1394 1.85594 7.83401 1.58895C9.52863 1.32197 11.2636 1.64401 12.7495 2.50136M6.74976 8.24976L8.99976 10.4998L16.4998 2.99976",
      "stroke": "#4CAF50",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_166_8935"
    }
  }, [_c('rect', {
    attrs: {
      "width": "18",
      "height": "18",
      "fill": "white"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Transportador validado com sucesso na ANTT.")])]) : _vm._e(), _vm._v(" "), (_vm.anttStatus === 'error') ? _c('div', {
    attrs: {
      "id": "antt-feedback-error"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "22",
      "viewBox": "0 0 20 22",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', {
    attrs: {
      "clip-path": "url(#clip0_166_9400)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.0001 20.3332C14.6025 20.3332 18.3334 16.6022 18.3334 11.9998C18.3334 7.39746 14.6025 3.6665 10.0001 3.6665C5.39771 3.6665 1.66675 7.39746 1.66675 11.9998C1.66675 16.6022 5.39771 20.3332 10.0001 20.3332Z",
      "stroke": "#E00000",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 8.6665V11.9998",
      "stroke": "#E00000",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10 15.3335H10.0083",
      "stroke": "#E00000",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]), _vm._v(" "), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "clip0_166_9400"
    }
  }, [_c('rect', {
    attrs: {
      "width": "20",
      "height": "20",
      "fill": "white",
      "transform": "translate(0 2)"
    }
  })])])]), _vm._v(" "), _c('span', [_vm._v("Não foi possível validar na ANTT. Verifique se os dados estão corretos.")])]) : _vm._e(), _vm._v(" "), (_vm.mostrarAvisoAntt && _vm.transportadorPendente) ? _c('div', {
    attrs: {
      "id": "antt-aviso"
    }
  }, [_vm._v("\n          Valide o transportador na ANTT para continuar.\n        ")]) : _vm._e()]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 1) ? _c('div', {
    attrs: {
      "id": "details-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "plate-form-model-container"
    }
  }, [_c('h3', {
    attrs: {
      "id": "plate-form-model"
    }
  }, [_vm._v(_vm._s(_vm.PlateFormat(_vm.plate)))]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "plate-edit-button"
    },
    on: {
      "click": _vm.StepBack
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/img/icons/pen-icons.svg"),
      "id": "edit-svg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "plate-container"
    }
  }, [_c('div', [_c('h5', {
    attrs: {
      "id": "brand-form-model"
    }
  }, [_vm._v("\n          Marca "), _c('span', {
    attrs: {
      "id": "brand-name"
    }
  }, [_vm._v(_vm._s(_vm.brandName))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "plate-form-model-container-mobile"
    }
  }, [_c('h3', {
    attrs: {
      "id": "plate-form-model"
    }
  }, [_vm._v(_vm._s(_vm.PlateFormat(_vm.plate)))]), _vm._v(" "), _c('button', {
    attrs: {
      "id": "plate-edit-button"
    },
    on: {
      "click": function($event) {
        _vm.stepForm = 0
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/img/icons/pen-icons.svg"),
      "id": "edit-svg"
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "model-container-form-model"
    }
  }, [_c('dropdownV2', {
    attrs: {
      "placeholder": 'Modelo do veículo',
      "arrayRender": _vm.arrayModelsByNetrin,
      "disabled": false
    },
    on: {
      "ClickHandler": _vm.getAxes
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "axes-container"
    }
  }, [(_vm.showAxes) ? _c('dropdownV2', {
    attrs: {
      "placeholder": _vm.placeHolderFixed == '' ? 'Eixos do veículo' : _vm.placeHolderFixed,
      "disabled": _vm.disableAxes,
      "arrayRender": _vm.axes
    },
    on: {
      "ClickHandler": _vm.setAxes
    }
  }) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), (
    _vm.stepForm == 1 &&
    _vm.modelName &&
    _vm.brandName &&
    _vm.axeNameSelected &&
    _vm.axeIdSelected
  ) ? _c('div', {
    staticClass: "btn-save-div"
  }, [_c('button', {
    attrs: {
      "id": "btn-save"
    },
    on: {
      "click": _vm.ShowModal
    }
  }, [_vm._v("Salvar")])]) : _vm._e(), _vm._v(" "), (_vm.stepForm == 404) ? _c('div', [_c('div', {
    attrs: {
      "id": "form-netrim-container"
    }
  }, [_c('div', {
    staticClass: "inputs-netrim-off"
  }, [_c('label', {
    staticClass: "label-netrim-off"
  }, [_vm._v("Placa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|plateValid|plateExist'),
      expression: "'required|plateValid|plateExist'"
    }, {
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.plate),
      expression: "plate",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control text-uppercase plate-input-netrim-off margin-t5",
    attrs: {
      "id": "plate-input-netrin-off",
      "type": "text",
      "name": "plate",
      "data-vv-validate-on": "blur",
      "spellcheck": "false",
      "autocomplete": "off",
      "autocorrect": "off",
      "autocapitalize": "off",
      "maxlength": "7"
    },
    domProps: {
      "value": (_vm.plate)
    },
    on: {
      "change": function($event) {
        _vm.plate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputs-netrim-off"
  }, [_c('label', {
    staticClass: "label-netrim-off"
  }, [_vm._v("Marca")]), _vm._v(" "), _c('dropdownV2', {
    attrs: {
      "placeholder": '',
      "arrayRender": _vm.netrimErrorBrands,
      "disabled": false
    },
    on: {
      "ClickHandler": _vm.getModels
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inputs-netrim-off"
  }, [_c('label', {
    staticClass: "label-netrim-off"
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('dropdownV2', {
    attrs: {
      "placeholder": '',
      "arrayRender": _vm.models,
      "disabled": false
    },
    on: {
      "ClickHandler": _vm.setModels
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inputs-netrim-off"
  }, [_c('label', {
    staticClass: "label-netrim-off"
  }, [_vm._v("Eixos")]), _vm._v(" "), _c('dropdownV2', {
    attrs: {
      "placeholder": '',
      "arrayRender": _vm.axes,
      "disabled": false
    },
    on: {
      "ClickHandler": _vm.setAxes
    }
  })], 1)]), _vm._v(" "), (_vm.validatePlate) ? _c('div', {
    attrs: {
      "id": "error-msg"
    }
  }, [_c('h2', [_vm._v("Placa Inválida!")])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "button-container"
    }
  }, [(_vm.modelName && _vm.brandName && _vm.axeNameSelected && _vm.axeIdSelected) ? _c('div', {
    staticClass: "btn-save-div"
  }, [_c('button', {
    attrs: {
      "id": "btn-save"
    },
    on: {
      "click": _vm.AddVehicleNetrimOff
    }
  }, [_vm._v("Salvar")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.modalConfirmVisibility) ? _c('form-modal', {
    attrs: {
      "plate": _vm.plate,
      "brand": _vm.brandName,
      "model": _vm.modelName
    },
    on: {
      "ClickHandlerCancel": _vm.RemoveModal,
      "ClickHandlerContinue": _vm.AddVehicle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.modalNewSearch) ? _c('form-modal-new-search', {
    on: {
      "ClickHandlerCancel": _vm.CloseModalNewSearch,
      "ClickHandlerContinue": _vm.refreshPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.netrinOffVisibility) ? _c('form-modal', {
    attrs: {
      "plate": _vm.plate,
      "brand": _vm.brandName,
      "model": _vm.modelName
    },
    on: {
      "ClickHandlerCancel": _vm.RemoveModal,
      "ClickHandlerContinue": _vm.AddVehicle
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loadingV2') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "id": "cpf-cnpj-label",
      "for": "cpf-cnpj-input"
    }
  }, [_vm._v("\n          CNPJ ou CPF do transportador"), _c('span', {
    staticClass: "required-asterisk"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-17eb94bd!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Adhesion/FormVehicle/FormVehicle.vue
// module id = 2054
// module chunks = 1